import { ThunkApiType } from 'types/storeTypes';
import authFetch, { checkForUnauthorizedResponse } from 'utils/axios';

export const getClaimsStatusesThunk = async (
	_: string,
	thunkAPI: ThunkApiType,
) => {
	let getClaimsStatusesURL = '/claim/status';

	try {
		const response = await authFetch.get(getClaimsStatusesURL);
		return response.data;
	} catch (error: ThunkApiType) {
		return checkForUnauthorizedResponse(error, thunkAPI);
	}
};

export const getReturnStatusesThunk = async (
	_: object,
	thunkAPI: ThunkApiType,
) => {
	try {
		const response = await authFetch.get(`returns/statuses`);
		return response.data;
	} catch (error: ThunkApiType) {
		return checkForUnauthorizedResponse(error, thunkAPI);
	}
};

export const getFraudStatusesThunk = async (
	_: string,
	thunkAPI: ThunkApiType,
) => {
	const getFraudStatusesURL = '/frauds/statuses';

	try {
		const response = await authFetch.get(getFraudStatusesURL);
		return response.data;
	} catch (error: ThunkApiType) {
		return checkForUnauthorizedResponse(error, thunkAPI);
	}
};

export const getComplaintStatusesThunk = async (
	_: string,
	thunkAPI: ThunkApiType,
) => {
	const getComplaintStatusesURL = '/complaints/statuses';

	try {
		const response = await authFetch.get(getComplaintStatusesURL);
		return response.data;
	} catch (error: ThunkApiType) {
		return checkForUnauthorizedResponse(error, thunkAPI);
	}
};

export const getComplaintTypeThunk = async (
	_: string,
	thunkAPI: ThunkApiType,
) => {
	const getComplaintTypesURL = '/complaints/types';

	try {
		const response = await authFetch.get(getComplaintTypesURL);
		return response.data;
	} catch (error: ThunkApiType) {
		return checkForUnauthorizedResponse(error, thunkAPI);
	}
};

export const getComplaintOutcomesThunk = async (
	_: string,
	thunkAPI: ThunkApiType,
) => {
	const getComplaintOutcomesURL = '/complaints/outcomes';

	try {
		const response = await authFetch.get(getComplaintOutcomesURL);
		return response.data;
	} catch (error: ThunkApiType) {
		return checkForUnauthorizedResponse(error, thunkAPI);
	}
};
